import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDqcFDscTwAQdN-6YX3-ikLQu1-KWPBQoM",
  authDomain: "flirttool-320420.firebaseapp.com",
  projectId: "flirttool-320420",
  storageBucket: "flirttool-320420.appspot.com",
  messagingSenderId: "878518436397",
  appId: "1:878518436397:web:2a3f399a6ae97817456ea4",
  measurementId: "G-DHRSBKJFCS",
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

export const loginWithGoogle = async () => {
  try {
    let result = await signInWithPopup(auth, provider);
    const credential = GoogleAuthProvider.credentialFromResult(result);
    // const token = credential.accessToken;
    const user = result.user;
    return user;
  } catch (e) {
    throw new Error(e);
  }
};

export const loginWithFacebook = async () => {
  try {
    let result = await signInWithPopup(auth, facebookProvider);
    const credential = FacebookAuthProvider.credentialFromResult(result);
    // const token = credential.accessToken;
    const user = result.user;
    return user;
  } catch (e) {
    throw new Error(e);
  }
};
// {
//   31|index  |   name: 'Sumit Chauhan',
//   31|index  |   picture: 'https://lh3.googleusercontent.com/a/ACg8ocLfgrIR4znZncc_tClw2vK28IqZPIglKaAWVVRvkl5cV6rHpaxz=s96-c',
//   31|index  |   iss: 'https://securetoken.google.com/mazu-6d2fe',
//   31|index  |   aud: 'mazu-6d2fe',
//   31|index  |   auth_time: 1714991477,
//   31|index  |   user_id: '4J1qpyDJ0iZLbkJzkDZDWbfOaf92',
//   31|index  |   sub: '4J1qpyDJ0iZLbkJzkDZDWbfOaf92',
//   31|index  |   iat: 1714991477,
//   31|index  |   exp: 1714995077,
//   31|index  |   email: 'sumitchauhan9807666@gmail.com',
//   31|index  |   email_verified: true,
//   31|index  |   firebase: {
//   31|index  |     identities: { 'google.com': [Array], email: [Array] },
//   31|index  |     sign_in_provider: 'google.com'
//   31|index  |   },
//   31|index  |   uid: '4J1qpyDJ0iZLbkJzkDZDWbfOaf92'
//   31|index  | }
